module.exports = __webpack_public_path__ + "static/close-4dc22cb647895d1d743a334cf46d92f8.svg";